
import React, { FC, JSX } from "react";
import { UserRole, UserDetails } from "../../types/api";
import UserManagementTable from "../user/UserManagementTable";
import Modal from "../ui/Modal";

interface UserSelectionModalProps {
  onSelect: (userId: string) => void;
  onClose: () => void;
  isOpen: boolean;
  existingApplicantIds?: (string|undefined)[];
}

const UserSelectionModal: FC<UserSelectionModalProps> = ({
  onSelect,
  onClose,
  isOpen,
  existingApplicantIds,
}): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Select a User" size="xl">
      <UserManagementTable
        isAdminView={true}
        pageTitle=""
        pageDescription=""
        showFilters={{
          dateRange: true,
          status: true
        }}
        filterRole={["Intern", "Jobseeker"]}
        tableView={true}
        onSelect={onSelect}
        defaultItemsPerPage={5}
        extraFilters={(user: UserDetails) => 
            !existingApplicantIds?.includes(user.userId)
        }
      />
    </Modal>
  );
};

export default UserSelectionModal;
